<div
  class:bx--skeleton__placeholder="{true}"
  {...$$restProps}
  on:click
  on:mouseover
  on:mouseenter
  on:mouseleave
></div>
